import React, { useContext } from 'react';
import axios from 'axios';
import Layout from '../../components/Layout';
import ImagenFondo from '../../medatatheme/assets/images/item.png';
import HomeCardsLinks from '../../components/Medata/home/home-cards-links';
import HomeDataSets from '../../components/Medata/home/home-data-sets';
import HomeDataTopics from '../../components/Medata/home/home-data-topics';
import HomeNewslater from '../../components/Medata/home/home-newslater';
import HomeReports from '../../components/Medata/home/home-reports';
import HomeSocialMedia from '../../components/Medata/home/home-social-media';
import { MedataContext } from '../../ContexMedata';
import HomeHistorys from '../../components/Medata/home/home-historys';
import HomeSurvey from '../../components/Medata/home/home-survey';

const Home = () => {
  const { datasetsL, publishersL, items, fDatasets, boardsLength, downloads,
    visits } =
    useContext(MedataContext);

  const textReport =
    'En esta sección encontrarás los conjuntos de datos más recientes publicados por las diferentes dependencias.';

  return (
    <Layout title="Inicio">
      <section className="data-section">
        <div className="container-home">
          <p id="text-header-mobile" class="text text-center">
            <b>
              Encuentre los datos abiertos generados y publicados por las
              diferentes dependencias de laAlcaldía de Medellín,
            </b>
            <br />
            además de las visualizaciones y análisis que se han creado para
            generar valor y conocimiento para los ciudadanos.
          </p>
          <HomeCardsLinks />
          <HomeDataSets
            dataLength={
              datasetsL !== 0 && boardsLength !== 0
                ? datasetsL - boardsLength
                : 0
            }
            publishersLength={publishersL}
            boardsLength={boardsLength}
            downloads={downloads}
            visits={visits}
          />
        </div>
        <div className="items-image">
          <img src={ImagenFondo} alt="Imagen complementaria lateral" />
        </div>
      </section>
      <section className="category-section">
        <div className="container-home">
          <HomeDataTopics items={items} />
        </div>
      </section>
      <section className="blog-section">
        <div className="container-home">
          <HomeReports items={fDatasets} text={textReport} />
        </div>
        <div className="container-home pt-0">
          <HomeHistorys />
        </div>
        <div className="blog-image">
          <img src={ImagenFondo} alt="Imagen complementaria lateral" />
        </div>
      </section>
      <section className="newsletter-section">
        <div className="container-home">
          <HomeSurvey />
        </div>
      </section>
      <section className="social-section">
        <div className="container-home mb-5">
          <HomeSocialMedia />
        </div>
      </section>
    </Layout>
  );
};

export default Home;
